
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/design-system/tree-progression",
      function () {
        return require("private-next-pages/design-system/tree-progression.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/design-system/tree-progression"])
      });
    }
  